(function () {
  const MORE = { en: "Read more", fr: "Lire la suite", de: "Weiterlesen", es: "Leer más", it: "Leggi di più" };
  const LESS = { en: "Show less", fr: "Réduire", de: "Weniger", es: "Ver menos", it: "Riduci" };
  const LOCALE = { FR: "fr", US: "en", DE: "de", ES: "es", IT: "it" };

  function lang() {
    const country = (document.documentElement.dataset.country || "").toUpperCase();
    if (LOCALE[country]) return LOCALE[country];
    return (document.documentElement.lang || "en").slice(0, 2);
  }

  function bindCarousel(root) {
    const track = root.querySelector("[data-reviews-track]");
    const prev = root.querySelector("[data-reviews-prev]");
    const next = root.querySelector("[data-reviews-next]");
    if (!track || !prev || !next) return;
    const step = () => Math.max(track.clientWidth * 0.86, 280);
    prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  }

  function bindMore(card) {
    const body = card.querySelector(".reviews-body");
    const btn = card.querySelector(".reviews-more");
    if (!body || !btn) return;
    const attach = () => {
      if (btn.dataset.bound === "1") return;
      if (body.scrollHeight <= body.clientHeight + 2) return;
      btn.dataset.bound = "1";
      btn.hidden = false;
      btn.textContent = MORE[lang()] || MORE.en;
      btn.setAttribute("data-i18n", "reviews.more");
      btn.addEventListener("click", () => {
        const open = body.classList.toggle("is-open");
        const pack = open ? LESS : MORE;
        btn.textContent = pack[lang()] || pack.en;
        btn.setAttribute("data-i18n", open ? "reviews.less" : "reviews.more");
      });
    };
    attach();
    requestAnimationFrame(attach);
  }

  function bindLightbox(root) {
    const dialog = root.querySelector("[data-reviews-lightbox]");
    if (!dialog || typeof dialog.showModal !== "function") return;
    const frame = dialog.querySelector("img");
    const closeBtn = dialog.querySelector("[data-reviews-lightbox-close]");
    if (!frame || !closeBtn) return;

    const close = () => {
      if (dialog.open) dialog.close();
    };

    closeBtn.addEventListener("click", close);
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener("keydown", (event) => {
      if (event.key === "Escape") close();
    });

    root.querySelectorAll("[data-reviews-photo]").forEach((btn) => {
      const img = btn.parentElement && btn.parentElement.querySelector(".reviews-photo img");
      if (!img) return;
      btn.addEventListener("click", () => {
        frame.src = img.currentSrc || img.src;
        frame.alt = img.alt || "";
        dialog.showModal();
        closeBtn.focus();
      });
    });
  }

  function boot() {
    document.querySelectorAll(".reviews-board").forEach((root) => {
      bindCarousel(root);
      bindLightbox(root);
    });
    document.querySelectorAll(".reviews-card").forEach(bindMore);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
